import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { fetchSingleMaterial, updateMaterialEntry } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';


const MaterialEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        materialId: parseInt(Id),
        materialNm: '',
        desp: '',
        size: '',
        pkts: '',
        packetqty: '',
        totqty: '',
        mtype: '',
        hsn: '',
        userId: userdata?.ID,
        departId: ''
    });

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const singleMaterial = useSelector((state) => state.MaterialData.singleMaterial || { data: [] });
    const loclist = useSelector(selectlocationdata);
    const departlist = useSelector(selectDaparement);
    useEffect(() => {
        dispatch(fetchSingleMaterial(Id));
        dispatch(fetchLocationData());
        dispatch(fetchDepartmentData());
    }, [dispatch, Id]);

    useEffect(() => {
        if (singleMaterial.data.length > 0) {
            const item = singleMaterial.data[0];
            setFormData({
                ...formData,
                materialNm: item.materialNm,
                desp: item.description,
                size: item.size,
                pkts: item.packets,
                pktqty: item.packetqty,
                mtype: item.mtype,
                totqty: item.totqty,
                departId: item.departId,
                hsn: item.hsn,
            });
        }
    }, [singleMaterial]);
    // console.log(singleMaterial)
    if (!singleMaterial) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const upperValue = value.toUpperCase();

        // Update form data
        let updatedForm = {
            ...formData,
            [name]: upperValue
        };

        // Auto-calculate total qty when pkts or pktqty changes
        if (name === 'pkts' || name === 'pktqty') {
            const pkts = parseFloat(
                name === 'pkts' ? upperValue : formData.pkts
            ) || 0;
            const pktqty = parseFloat(
                name === 'pktqty' ? upperValue : formData.pktqty
            ) || 0;
            updatedForm.totqty = (pkts * pktqty).toFixed(2);
        }

        setFormData(updatedForm);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const result = await dispatch(updateMaterialEntry(formData)).unwrap();
            console.log('POST request successful!', result);
            alert("Material Updated...");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }


    };
    const mtype = [
        { key: 'Pcs', ID: 'Pcs' },
        { key: 'Inch', ID: 'Inch' }
    ]

    const dropdownFirm = [
        // {
        //     label: 'Firm',
        //     id: 'firmId',
        //     options: firmlist?.data || [],
        //     value: formData.firmId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
        //     getOptionLabel: (option) => option.firmNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // },
        // {
        //     label: 'Location',
        //     id: 'locId',
        //     options: loclist?.data || [],
        //     value: formData.locId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
        //     getOptionLabel: (option) => option.locNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // },


        {
            label: 'M. Type',
            id: 'mtype',
            options: mtype || [],
            value: formData.mtype,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'mtype', value: newValue ? newValue.ID : '' } }, 'mtype'),
            getOptionLabel: (option) => option.key || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },

        {
            label: 'Department',
            id: 'departId',
            options: departlist?.data || [],
            value: formData.departId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'departId', value: newValue ? newValue.ID : '' } }, 'departId'),
            getOptionLabel: (option) => option.departNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },

        },
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Material Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>




                                {[
                                    { label: 'Material Name', name: 'materialNm' },
                                    { label: 'Description', name: 'desp' },
                                    { label: 'Size', name: 'size' },
                                    { label: 'Per Packet Qty', name: 'pkts' },
                                    { label: 'HSN Code', name: 'hsn' },
                                    //  { label: ' Packet Qty', name: 'pktqty' },
                                    //   { label: 'Total Qty', name: 'totqty' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        //  inputProps={{ style: styled.input }}
                                                        inputProps={{
                                                            style: styled.input,
                                                            readOnly: field.name === 'totqty'   // 👈 makes Total Qty read-only
                                                        }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>


            </div>
        </>
    );
}

export default MaterialEdit;
